import React from 'react';
import { Box, Typography, Button, Card, CardMedia, CardContent } from '@mui/material';
import { useNavigate } from 'react-router-dom'; // <-- Add this import
import { getImageSrc } from '../../../utils/imageMapping';
import { Images } from '../../../utils/Images';

const MonthlyDonationProgramCard = ({ 
  id,
  image,
  taxBenefit,
  title,
  peopleJoined,
  isMobile = false,
  isMediumScreen = false,
  isTablet = false,
  isDesktop = false
}) => {
  const navigate = useNavigate(); // <-- Add this line

  // Responsive styles function
  const getResponsiveStyles = () => {
    if (isMobile) {
      return {
        card: {
          width: '280px',
          height: '320px',
          borderRadius: '12px',
          paddingTop: '12px',
          paddingRight: '12px',
          paddingBottom: '12px',
          paddingLeft: '12px'
        },
        image: {
          width: '256px',
          height: '144px',
          borderRadius: '10px'
        },
        taxBenefit: {
          width: '75px',
          height: '26px',
          fontSize: '10px',
          top: '0px',
          right: '0px'
        },
        title: {
          fontSize: '14px',
          lineHeight: '18px',
          marginTop: '12px',
          marginBottom: '10px'
        },
        peopleIcon: {
          width: '20px',
          height: '20px'
        },
        peopleText: {
          fontSize: '12px',
          lineHeight: '18px'
        },
        button: {
          paddingTop: '12px',
          paddingRight: '20px',
          paddingBottom: '12px',
          paddingLeft: '20px',
          fontSize: '12px',
          lineHeight: '12px',
          borderRadius: '8px'
        }
      };
    } else if (isMediumScreen) {
      return {
        card: {
          width: '320px',
          height: '360px',
          borderRadius: '13px',
          paddingTop: '13px',
          paddingRight: '13px',
          paddingBottom: '13px',
          paddingLeft: '13px'
        },
        image: {
          width: '294px',
          height: '165px',
          borderRadius: '11px'
        },
        taxBenefit: {
          width: '80px',
          height: '27px',
          fontSize: '10px',
          top: '0px',
          right: '0px'
        },
        title: {
          fontSize: '14px',
          lineHeight: '19px',
          marginTop: '13px',
          marginBottom: '11px'
        },
        peopleIcon: {
          width: '21px',
          height: '21px'
        },
        peopleText: {
          fontSize: '12px',
          lineHeight: '19px'
        },
        button: {
          paddingTop: '12px',
          paddingRight: '21px',
          paddingBottom: '12px',
          paddingLeft: '21px',
          fontSize: '12px',
          lineHeight: '12px',
          borderRadius: '8px'
        }
      };
    } else if (isTablet) {
      return {
        card: {
          width: '350px',
          height: '370px',
          borderRadius: '14px',
          paddingTop: '14px',
          paddingRight: '14px',
          paddingBottom: '14px',
          paddingLeft: '14px'
        },
        image: {
          width: '322px',
          height: '181px',
          borderRadius: '12px'
        },
        taxBenefit: {
          width: '85px',
          height: '28px',
          fontSize: '11px',
          top: '0px',
          right: '0px'
        },
        title: {
          fontSize: '15px',
          lineHeight: '20px',
          marginTop: '14px',
          marginBottom: '12px'
        },
        peopleIcon: {
          width: '22px',
          height: '22px'
        },
        peopleText: {
          fontSize: '13px',
          lineHeight: '20px'
        },
        button: {
          paddingTop: '13px',
          paddingRight: '22px',
          paddingBottom: '13px',
          paddingLeft: '22px',
          fontSize: '13px',
          lineHeight: '13px',
          borderRadius: '9px'
        }
      };
    } else {
      return {
        card: {
          width: '417px',
          height: '414px',
          borderRadius: '16px',
          paddingTop: '16px',
          paddingRight: '16px',
          paddingBottom: '16px',
          paddingLeft: '16px'
        },
        image: {
          width: '385px',
          height: '216.56248474121094px',
          borderRadius: '20px'
        },
        taxBenefit: {
          width: '95px',
          height: '32px',
          fontSize: '12px',
          top: '0px',
          right: '0px'
        },
        title: {
          fontSize: '16px',
          lineHeight: '22px',
          marginTop: '16px',
          marginBottom: '14px'
        },
        peopleIcon: {
          width: '24px',
          height: '24px'
        },
        peopleText: {
          fontSize: '14px',
          lineHeight: '22px'
        },
        button: {
          paddingTop: '15px',
          paddingRight: '24px',
          paddingBottom: '15px',
          paddingLeft: '24px',
          fontSize: '14px',
          lineHeight: '14px',
          borderRadius: '10px'
        }
      };
    }
  };

  const styles = getResponsiveStyles();
  return (
    <Card sx={{ 
      width: styles.card.width,
      height: styles.card.height,
      borderRadius: styles.card.borderRadius,
      paddingTop: styles.card.paddingTop,
      paddingRight: styles.card.paddingRight,
      paddingBottom: '0px',
      paddingLeft: styles.card.paddingLeft,
      background: '#FFFFFF',
      boxShadow: '0px 10px 26px 0px #0000000A',
      position: 'relative',
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column',
    }}>
      {/* Image */}
      <Box sx={{ position: 'relative' }}>
        <CardMedia
          component="img"
          image={image && (image.startsWith('http://') || image.startsWith('https://')) ? image : getImageSrc(image)}
          alt={title}
          sx={{
            width: styles.image.width,
            height: styles.image.height,
            borderRadius: styles.image.borderRadius,
            objectFit: 'cover'
          }}
        />
        
        {/* Tax Benefit Badge - Inside Image */}
        {taxBenefit && (
          <Box
            sx={{
              position: 'absolute',
              top: styles.taxBenefit.top,
              right: styles.taxBenefit.right,
              width: styles.taxBenefit.width,
              height: styles.taxBenefit.height,
              borderTopLeftRadius: '3px',
              borderTopRightRadius: '20px',
              borderBottomLeftRadius: '20px',
              borderBottomRightRadius: '3px',
              paddingTop: '8px',
              paddingBottom: '8px',
              background: 'linear-gradient(295deg, #EC1B26, #FF4A60)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 2
            }}
          >
            <Typography
              sx={{
                fontWeight: 700,
                fontSize: styles.taxBenefit.fontSize,
                lineHeight: '16px',
                letterSpacing: '-2%',
                color: '#FFFFFF'
              }}
            >
              Tax Benefit
            </Typography>
          </Box>
        )}
      </Box>


      {/* Card Content */}
      <CardContent sx={{ 
        padding: 0, 
        paddingBottom: 0,
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        justifyContent: 'space-between'
      }}>
        {/* Title */}
        <Typography
          sx={{
            fontWeight: 700,
            fontSize: styles.title.fontSize,
            lineHeight: styles.title.lineHeight,
            letterSpacing: '0%',
            verticalAlign: 'middle',
            textTransform: 'capitalize',
            color: '#1D1D1B',
            marginTop: styles.title.marginTop,
            marginBottom: styles.title.marginBottom,
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
          }}
        >
          {title}
        </Typography>

        {/* Spacer to push bottom content down */}
        <Box sx={{ flex: 1 }} />

        {/* Bottom Section - People Joined and Button */}
        <Box>
          {/* People Joined */}
          <Box sx={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: isMobile ? '7px' : '9px',
            marginBottom: isMobile ? '16px' : '20px'
          }}>
            <img
              src={Images.people}
              alt="People joined icon"
              style={{
                width: styles.peopleIcon.width,
                height: styles.peopleIcon.height,
                objectFit: 'contain'
              }}
            />
            <Typography
              sx={{
                fontWeight: 600,
                fontSize: styles.peopleText.fontSize,
                lineHeight: styles.peopleText.lineHeight,
                letterSpacing: '0%',
                verticalAlign: 'middle',
                textTransform: 'capitalize',
                color: '#4A4A49'
              }}
            >
              {peopleJoined} Peoples Joined In A Mission.
            </Typography>
          </Box>

          {/* Subscribe Button */}
          <Button
            variant="contained"
            fullWidth
            sx={{
              borderRadius: styles.button.borderRadius,
              paddingTop: styles.button.paddingTop,
              paddingRight: styles.button.paddingRight,
              paddingBottom: styles.button.paddingBottom,
              paddingLeft: styles.button.paddingLeft,
              background: '#F04951',
              boxShadow: '0px 4px 0px 0px #141414',
              textTransform: 'none',
              '&:hover': {
                backgroundColor: '#e03e46'
              }
            }}
            onClick={() => navigate(`/monthly-donation-detail${id ? `?id=${id}` : ''}`)} 
          >
            <Typography
              sx={{
                fontWeight: 700,
                fontSize: styles.button.fontSize,
                lineHeight: styles.button.lineHeight,
                letterSpacing: '0%',
                textAlign: 'center',
                verticalAlign: 'middle',
                color: '#FFFFFF'
              }}
            >
              Subscribe Monthly
            </Typography>
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
};

export default MonthlyDonationProgramCard;
